<template>
  <div class="app-container">
    <div class="top_btns clearfix">
      <div class="left_box">
        <el-input size="mini" placeholder="公司名称" v-model="listQuery.name" style="width:150px" @keyup.enter="getList"></el-input>
        <el-button size="mini" type="primary" @click="getList" style="margin-right:10px" >搜索</el-button>
        <search @success="getList">
          <el-form style="margin:11px 0px 0px -26px;width:700px" class="styleForm">
            <el-form-item label="纳税人类型 ：" :label-width="formLabelWidth">          
              <selecttaxtype v-model:type="listQuery.type"></selecttaxtype>
            </el-form-item>
            <el-form-item label="选择人员 ：" :label-width="formLabelWidth">   
              <selectuser code="addCustomer" v-model:userId="listQuery.userId"></selectuser>
            </el-form-item>
            <el-form-item label="所属区域 ：" :label-width="formLabelWidth"> 
              <selectcity v-model:citys="listQuery.districtCode"></selectcity>
            </el-form-item>
            <el-form-item label="采集状态 ：" :label-width="formLabelWidth"> 
              <selectCollectStatus v-model:collectStatus="listQuery.setUpStatusCj"></selectCollectStatus>
            </el-form-item>
            <el-form-item label="建账状态 ：" :label-width="formLabelWidth"> 
              <selectJzStatus v-model:jzStatus="listQuery.setUpStatusJz"></selectJzStatus>
            </el-form-item>
            <el-form-item label="匹配状态 ：" :label-width="formLabelWidth"> 
              <selectPpStatus v-model:ppStatus="listQuery.setUpStatusPp"></selectPpStatus>
            </el-form-item>
          </el-form>
        </search>
        <!-- 悬浮导航 -->
      </div>
      <!-- <div  class="right_box">
        <el-button size="mini" type="primary" plain v-if="tabName == 'first'" @click="gather">采集</el-button>
        <el-button size="mini" type="primary" plain v-if="tabName == 'first'" @click="skipCollection" :loading="loading">跳过采集</el-button>
      </div> -->
    </div>
    <template v-if="tabName == 'first'">
      <contentTable ref="clientList" :tabName="tabName" @gather="gaOption" :listQuery="listQuery"></contentTable>
    </template>
  </div>
</template>

<script>
import selecttaxtype from "@/components/Screening/selecttaxtype";
import selectuser from "@/components/Screening/selectuser";
import selectcity from "@/components/Screening/selectcity";
import selectCollectStatus from "@/components/Screening/selectCollectStatus";
import selectJzStatus from "@/components/Screening/selectJzStatus";
import selectPpStatus from "@/components/Screening/selectPpStatus";
import contentTable from "./components/contentTable.vue";
// import { delCompany } from "@/api/company";
import { sendTask } from "@/api/collection"

export default {
  name: "addCustomer",
  components:{
    selecttaxtype,
    selectuser,
    selectcity,
    selectCollectStatus,
    selectJzStatus,
    selectPpStatus,
    contentTable,
  },
  data(){
    return{
      activeName: "first",
      tabName:'first',
      listQuery: {
        page: 1,
        limit: 20,
        status:"1",
      },
      formLabelWidth: '170px',
      loading:false,
      gatherId:{}  //表格ID
    }
  },
  activated() {
    this.activeName = this.tabName
    this.initBus()
    this.$bus.on("loadingClose", (val) => {
      this.loading = false
    });
  },
  methods:{
    initBus(){
      this.$bus.off("addCustomerUpdate")
      this.$bus.on("addCustomerUpdate", (val) => {
        this.getList()
      });
    },
    getList(){
      this.$refs.clientList.getList()
    },
    handleClick(tab, event) {
      this.listQuery.page = 1;
      this.listQuery.limit = 20;
      this.listQuery.status = "1"
      if (tab.props.label == "全部新增客户") {
        this.tabName = tab.props.name
      }else if (tab.props.label == "回收站") {
        this.tabName = tab.props.name
        this.listQuery.status = "9"
      }
    },
    companyfp(){
      this.$refs.clientList.companyfp()
    },
    automatic(){
      this.$refs.clientList.automatic()
    },
    skipCollection(){
      this.loading = true
      this.$refs.clientList.skipCollection()
    },
  }
}
</script>

<style lang="scss" scoped>
.top_btns {
  margin-bottom: 10px;
  width: 70%;
  .left_box{
    float: left;
    width: 70%;
  }
  .right_box {
    float: right;
    width: 30%;
    text-align: right;
  }
}
.el-select{
  margin: 0px;
}
</style>